export const getPrimevueConfig = () => ({
    unstyled: true,
    locale: {
        startsWith: "Začíná",
        contains: "Obsahuje",
        notContains: "Neobsahuje",
        endsWith: "Končí s",
        equals: "Je rovno",
        notEquals: "Není rovno",
        noFilter: "Bez filtru",
        lt: "Méně než",
        lte: "Méně než nebo rovno",
        gt: "Větší než",
        gte: "Větší nebo rovno",
        dateIs: "Datum je",
        dateIsNot: "Datum není",
        dateBefore: "Datum je před",
        dateAfter: "Datum je po",
        clear: "Vymazat",
        apply: "Potvrdit",
        matchAll: "Shoda všech",
        matchAny: "Shoda některých",
        addRule: "Přidat pravidlo",
        removeRule: "Odebrat pravidlo",
        accept: "Ano",
        reject: "Ne",
        choose: "Zvolit",
        upload: "Nahrát",
        cancel: "Zrušit",
        completed: "Dokončeno",
        pending: "Čeká",
        dayNames: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
        dayNamesShort: ["Ned", "Pon", "Úte", "Str", "Čtv", "Pát", "Sob"],
        dayNamesMin: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
        monthNames: [
            "Leden",
            "Únor",
            "Březen",
            "Duben",
            "Květen",
            "Červen",
            "Červenec",
            "Srpen",
            "Září",
            "Říjen",
            "Listopad",
            "Prosinec",
        ],
        monthNamesShort: ["Led", "Úno", "Bře", "Dub", "Kvě", "Čvn", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"],
        chooseYear: "Vybrat rok",
        chooseMonth: "Vybrat měsíc",
        chooseDate: "Vybrat datum",
        prevDecade: "Předchozí dekáda",
        nextDecade: "Následující dekáda",
        prevYear: "Předchozí rok",
        nextYear: "Následující rok",
        prevMonth: "Předchozí měsíc",
        nextMonth: "Následující měsíc",
        prevHour: "Předchozí hodina",
        nextHour: "Následující hodina",
        prevMinute: "Předchozí minuta",
        nextMinute: "Následující minuta",
        prevSecond: "Předchozí sekunda",
        nextSecond: "Další sekunda",
        am: "am",
        pm: "pm",
        today: "Dnes",
        weekHeader: "Týden",
        firstDayOfWeek: 1,
        dateFormat: "mm/dd/yy",
        weak: "Slabý",
        medium: "Střední",
        strong: "Silný",
        passwordPrompt: "Zadejte heslo",
        emptyFilterMessage: "Nebyly nalezeny žádné výsledky",
        searchMessage: "{0} výsledků je k dispozici",
        selectionMessage: "{0} položek vybráno",
        emptySelectionMessage: "Žádná vybraná položka",
        emptySearchMessage: "Nebyly nalezeny žádné výsledky",
        emptyMessage: "Žádné dostupné možnosti",
        aria: {
            trueLabel: "Pravda",
            falseLabel: "Nepravda",
            nullLabel: "Nevybráno",
            star: "1 hvězdička",
            stars: "{star} hvězdiček",
            selectAll: "Všechny položky vybrány",
            unselectAll: "Všechny položky nevybrány",
            close: "Zavřít",
            previous: "Předchozí",
            next: "Další",
            navigation: "Navigace",
            scrollTop: "Scrollovat nahoru",
            moveTop: "Přesunout nahoru",
            moveUp: "Přesunout nahoru",
            moveDown: "Přesunout dolů",
            moveBottom: "Přesunout dolů",
            moveToTarget: "Přesunout na cíl",
            moveToSource: "Přesunout na zdroj",
            moveAllToTarget: "Přesunout vše na cíl",
            moveAllToSource: "Přesunout vše do zdroje",
            pageLabel: "{page}",
            firstPageLabel: "První stránka",
            lastPageLabel: "Poslední stránka",
            nextPageLabel: "Další stránka",
            prevPageLabel: "Předchozí stránka",
            rowsPerPageLabel: "Řádky na stránku",
            previousPageLabel: "Předchozí stránka",
            jumpToPageDropdownLabel: "Přejít na výběr",
            jumpToPageInputLabel: "Přejít na input",
            selectRow: "Vybraný řádek",
            unselectRow: "Nevybraný řádek",
            expandRow: "Rozbalený řádek",
            collapseRow: "Sbalený řádek",
            showFilterMenu: "Zobrazit nabídku filtru",
            hideFilterMenu: "Skrýt nabídku filtru",
            filterOperator: "Filtr",
            filterConstraint: "Filtr",
            editRow: "Editace řádku",
            saveEdit: "Uložit",
            cancelEdit: "Zrušit úpravu",
            listView: "Zobrazení v řádku",
            gridView: "Zobrazení v mřížce",
            slide: "Slide",
            slideNumber: "{slideNumber}",
            zoomImage: "Přiblížit obrázek",
            zoomIn: "Přiblížit",
            zoomOut: "Oddálit",
            rotateRight: "Otočit doprava",
            rotateLeft: "Otočit doleva",
        },
    },
});
